import {
  GetterTree, Module, MutationTree, ActionTree, ActionContext,
} from 'vuex'
import { RootState } from '..'

export interface CompetitionState {
  isEnabled: boolean
}

const competitionState: CompetitionState = {
  isEnabled: false,
}

const mutations: MutationTree<CompetitionState> = {
  SET_COMPETITION_IS_ENABLED(state: CompetitionState, isEnabled) {
    state.isEnabled = isEnabled
  },
}

const getters: GetterTree<CompetitionState, RootState> = {
  competitionIsEnabled: (state: CompetitionState) => state.isEnabled,
}

export const competitionModule: Module<CompetitionState, RootState> = {
  state: competitionState,
  mutations,
  getters,
}
